import { IconName } from '../Icon';

import { HintVariant } from './Hint.types';

export const ICON_NAME_MAPPING: Record<HintVariant, IconName> = {
  info: 'info',
};
